export default {
    getNotifications:(state)=>state.notifications,
}